var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 80,
    viewBox: "0 0 216 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141 80a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5h65.946c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8H141Zm-57 0H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 64 0 60.418 0 56s4.054-8 9.054-8H60.79c5 0 9.054-3.582 9.054-8s-4.053-8-9.054-8H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H79v59a5 5 0 0 0 5 5Zm-5-64.069c-4.437-.515-7.862-3.87-7.862-7.931 0-4.418 4.053-8 9.054-8H84a5 5 0 0 0-5 5v10.931ZM206.946 48c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8S216 35.582 216 40s-4.054 8-9.054 8Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(79)",
    stroke: "#6A6666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.984 14.24h26-26Zm0 12 41.015-.245-41.015.244Zm0 13 41.015-.245-41.015.244Zm0 13 41.015-.245-41.015.244Zm0 13h26-26Z",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2,
    fill: "#FFF",
    transform: "rotate(1 8.977 13.618)",
    x: 6.977,
    y: 11.618,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2,
    fill: "#FFF",
    transform: "rotate(1 8.977 25.618)",
    x: 6.977,
    y: 23.618,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2,
    fill: "#FFF",
    transform: "rotate(1 8.977 38.618)",
    x: 6.977,
    y: 36.618,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2,
    fill: "#FFF",
    transform: "rotate(1 8.977 51.618)",
    x: 6.977,
    y: 49.618,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2,
    fill: "#FFF",
    transform: "rotate(1 8.977 64.618)",
    x: 6.977,
    y: 62.618,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2.5,
    x: 1.25,
    y: 1.25,
    width: 64.5,
    height: 77.5,
    rx: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackages);
export default __webpack_public_path__ + "static/media/packages.54ae939d6670bd27c63503ec7f0c80cd.svg";
export { ForwardRef as ReactComponent };